// extracted by mini-css-extract-plugin
module.exports = {"gridWrapper":"styles__gridWrapper--2j_qO","msg":"styles__msg--Xnvx-"};